import { RouteConfig } from 'vue-router';
import { PermissionLevel } from '@/utils/permission';

const LazyLayout = () => import('@/layout/index.vue');

export default [
  {
    children: [
      {
        component: () => import('@/pages/admin/security/roles/index.vue'),
        meta: {
          permissions: [{ Role: PermissionLevel.Read }],
          title: 'menu_admin_roles'
        },
        name: 'Roles',
        path: 'roles'
      },
      {
        component: () => import('@/pages/admin/security/roles/create.vue'),
        hidden: true,
        meta: {
          icon: 'edit',
          permissions: [{ Role: PermissionLevel.Write }],
          title: 'createRole'
        },
        name: 'CreateRole',
        path: 'roles/create'
      },
      {
        component: () => import('@/pages/admin/security/roles/edit.vue'),
        hidden: true,
        meta: {
          noCache: true,
          permissions: [{ Role: PermissionLevel.Read }],
          title: 'editRole'
        },
        name: 'EditRole',
        path: 'roles/edit/:id(\\d+)'
      },
      {
        component: () => import('@/pages/admin/security/users/index.vue'),
        meta: {
          permissions: [{ User: PermissionLevel.Read }],
          title: 'menu_admin_users'
        },
        name: 'Users',
        path: 'users'
      },
      {
        component: () => import('@/pages/admin/security/users/create.vue'),
        hidden: true,
        meta: {
          icon: 'edit',
          permissions: [{ User: PermissionLevel.Write }],
          title: 'createUser'
        },
        name: 'CreateUser',
        path: 'users/create'
      },
      {
        component: () => import('@/pages/admin/security/users/edit.vue'),
        hidden: true,
        meta: {
          noCache: true,
          permissions: [{ User: PermissionLevel.Read }],
          title: 'editUser'
        },
        name: 'EditUser',
        path: 'users/edit/:id(\\d+)'
      }
    ],
    component: LazyLayout,
    meta: { icon: 'peoples', title: 'menu_admin_security' },
    name: 'Security',
    path: '/security'
  } as RouteConfig,
  {
    children: [
      {
        component: () => import('@/pages/admin/application/languages/index.vue'),
        meta: {
          permissions: [{ Language: PermissionLevel.Read }],
          title: 'menu_admin_languages'
        },
        name: 'Languages',
        path: 'languages'
      },
      {
        component: () => import('@/pages/admin/application/languages/create.vue'),
        hidden: true,
        meta: {
          icon: 'edit',
          permissions: [{ Language: PermissionLevel.Write }],
          title: 'createLanguage'
        },
        name: 'CreateLanguage',
        path: 'languages/create'
      },
      {
        component: () => import('@/pages/admin/application/languages/edit.vue'),
        hidden: true,
        meta: {
          noCache: true,
          permissions: [{ Language: PermissionLevel.Read }],
          title: 'editLanguage'
        },
        name: 'EditLanguage',
        path: 'languages/edit/:id'
      },
      {
        component: () => import('@/pages/admin/application/translations/index.vue'),
        meta: {
          permissions: [{ Translation: PermissionLevel.Read }],
          title: 'menu_admin_translations'
        },
        name: 'Translations',
        path: 'translations'
      },
      {
        component: () => import('@/pages/admin/application/translations/edit.vue'),
        hidden: true,
        meta: {
          noCache: true,
          permissions: [{ Translation: PermissionLevel.Read }],
          title: 'editTranslation'
        },
        name: 'EditTranslation',
        path: 'translations/edit/:id'
      },
      {
        component: () => import('@/pages/admin/application/configuration/index.vue'),
        meta: {
          permissions: [{ Configuration: PermissionLevel.Read }],
          title: 'menu_admin_configuration'
        },
        name: 'Configuration',
        path: 'configuration'
      },
      {
        component: () => import('@/pages/admin/application/configuration/edit.vue'),
        hidden: true,
        meta: {
          noCache: true,
          permissions: [{ Configuration: PermissionLevel.Read }],
          title: 'editConfiguration'
        },
        name: 'EditConfiguration',
        path: 'configuration/edit/:id'
      },
      {
        component: () => import('@/pages/admin/maintenance/accesslog/index.vue'),
        meta: {
          permissions: [{ AccessLog: PermissionLevel.Read }],
          title: 'menu_admin_accesslog'
        },
        name: 'Access log',
        path: 'accesslog'
      },
      {
        component: () => import('@/pages/admin/maintenance/eventlog/index.vue'),
        meta: {
          permissions: [{ EventLog: PermissionLevel.Read }],
          title: 'menu_admin_eventlog'
        },
        name: 'Event Log',
        path: 'eventlog'
      },
      {
        component: () => import('@/pages/admin/application/customers/index.vue'),
        meta: {
          permissions: [{ Customer: PermissionLevel.Read }],
          title: 'menu_admin_customers'
        },
        name: 'Customers',
        path: 'customers'
      },
      {
        component: () => import('@/pages/admin/application/customers/create.vue'),
        hidden: true,
        meta: {
          icon: 'edit',
          permissions: [{ Customer: PermissionLevel.Write }],
          title: 'createCustomer'
        },
        name: 'CreateCustomer',
        path: 'customers/create'
      },
      {
        component: () => import('@/pages/admin/application/customers/edit.vue'),
        hidden: true,
        meta: {
          noCache: true,
          permissions: [{ Customer: PermissionLevel.Read }],
          title: 'editCustomer'
        },
        name: 'EditCustomer',
        path: 'customers/edit/:id'
      }
    ],
    component: LazyLayout,
    meta: { icon: 'star', title: 'menu_admin_application' },
    name: 'Application',
    path: '/application'
  } as RouteConfig,
  {
    children: [
      {
        component: () => import('@/pages/user/settings.vue'),
        meta: { noCache: true, title: 'userSettings' },
        name: 'Settings',
        path: 'settings'
      }
    ],
    component: LazyLayout,
    hidden: true,
    path: '/user',
    redirect: 'settings'
  } as RouteConfig
];
